import { HttpRequest, HttpMethod } from "./http";

// Variable-option promotion bundles (issue #33). Distinct from the flat
// discount campaigns served by AppCatalogCampaignProvider.
class AppCatalogPromotionBundleProvider extends HttpRequest {
    list(params) {
        return this.request(HttpMethod.Get, "/api/v1/bo/catalog/promotions", params);
    }

    get(id) {
        return this.request(HttpMethod.Get, `/api/v1/bo/catalog/promotions/${id}`);
    }

    create(payload) {
        return this.request(HttpMethod.Post, "/api/v1/bo/catalog/promotions", payload);
    }

    update(id, payload) {
        return this.request(HttpMethod.Put, `/api/v1/bo/catalog/promotions/${id}`, payload);
    }

    remove(id) {
        return this.request(HttpMethod.Delete, `/api/v1/bo/catalog/promotions/${id}`);
    }

    // ---- seller UI revamp 2026-10-03 (spec §3 BE-3) ----
    //
    // PATCH /api/v1/bo/catalog/promotions/:id/status  {status: 0|1}
    // 200 {id, status, updated_at}
    //
    // Not update() above: BOCatalogPromotionUpdate hard-deletes and re-inserts
    // slots, options and the gallery, so a partial PUT from the list's switch
    // would empty the bundle.
    setStatus(id, status) {
        return this.request(HttpMethod.Patch, `/api/v1/bo/catalog/promotions/${id}/status`, {
            status: Number(status) === 1 ? 1 : 0
        });
    }

    // type2 option picker — searches BO MariaDB wms_product.
    searchWmsProducts(params) {
        return this.request(HttpMethod.Get, "/api/v1/bo/catalog/wms-products", params);
    }
}

export default AppCatalogPromotionBundleProvider;
